import recurrenceMasterActions from './recurrenceMasterActions';
import bookForActions from './bookForActions';
import attendeesActions from './attendeesActions';

export default {
  ...recurrenceMasterActions,
  ...bookForActions,
  ...attendeesActions
};
